module.exports = __webpack_public_path__ + "static/img/certificate.17e861b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/certificate.png
// module id = 373
// module chunks = 1